<template>
  <b-card
    class="text-white h-100"
    body-class="p-3"
  >
    <template #header>
      <div>
        <i class="fa fa-ellipsis-v mr-2 drag-handle"></i>
        <strong>Notes</strong>
      </div>
    </template>
    <b-form-textarea
      v-model="modifiedNote"
      @change="changeNote"
      rows="4"
      class="bg-dark text-white"
      placeholder="Enter staff notes here..."
      :readonly="!hasPermission(UserNotesEdit) || userLock"
    ></b-form-textarea>

    <template #footer>
      <small class="text-muted">
        <i class="fa fa-info-circle"></i> Changes are saved automatically when you click outside the text box.
      </small>
    </template>
  </b-card>
</template>

<script>
import VueNotifications from 'vue-notifications'

export default {
  name: 'UserNotes',
  props: ['note', 'userLock'],

  data () {
    return {
      modifiedNote: this.note,
    }
  },
  watch: {
    // Ensure local state updates if parent prop changes
    note(newVal) {
      this.modifiedNote = newVal
    }
  },
  methods: {
    changeNote () {
      this.emit('changeUserNote', {
        username: this.$route.params.username,
        note: this.modifiedNote
      })
      // this.ChangeSuccessful()
    },
  },
  notifications: {
    ChangeSuccessful: {
      type: VueNotifications.types.success,
      title: 'Change successful!',
      message: 'Change was successful!'
    }
  }
}
</script>

<style scoped>
/* Optional: Ensure placeholder text is readable in dark mode */
::placeholder {
  color: #6c757d;
  opacity: 1;
}
</style>
